var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeSlashBold = function SvgEyeSlashBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m6 5 20 22m-6.637-7.3A4.95 4.95 0 0 1 16 21a5 5 0 0 1-3.363-8.7M9.25 8.575C4.15 11.15 2 16 2 16s4 9 14 9c2.343.02 4.657-.52 6.75-1.575m3.325-2.288C28.8 18.7 30 16 30 16s-4-9-14-9q-1.302-.002-2.588.213m3.525 3.875a4.99 4.99 0 0 1 4.038 4.437"
  })));
};
export default SvgEyeSlashBold;